// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
// components
import { Button } from '@ontruck/orc';

const mobileCSS = css`
  width: 100%;
`;

export default styled(Button)`
  ${media.lessThan('extraSmall')`${mobileCSS}`}
`;
